// 웹 푸시(Web Push / VAPID) 공통 타입과 zod 스키마.
// 사용자 앱/관리자 콘솔(구독 등록), API(구독 저장/발송)가 본 파일을 공유한다.

import { z } from "zod";

// 브라우저 PushManager.subscribe() 결과(PushSubscription.toJSON())의 필요한 부분.
//  - endpoint: 푸시 서비스가 발급한 구독 URL (고유 식별자).
//  - keys.p256dh: 클라이언트 공개키 (base64url). 페이로드 암호화(RFC8291)에 사용.
//  - keys.auth: 인증 시크릿 (base64url 16바이트).
export const pushSubscribeInputSchema = z.object({
  endpoint: z.string().url().max(1000),
  keys: z.object({
    p256dh: z.string().min(1).max(300),
    auth: z.string().min(1).max(100),
  }),
  // 진단용 (어느 기기/브라우저인지). 선택.
  userAgent: z.string().max(500).nullable().optional(),
});
export type PushSubscribeInput = z.infer<typeof pushSubscribeInputSchema>;

// 구독 해제 요청. endpoint 만으로 식별한다.
export const pushUnsubscribeInputSchema = z.object({
  endpoint: z.string().url().max(1000),
});
export type PushUnsubscribeInput = z.infer<typeof pushUnsubscribeInputSchema>;

// 서비스워커가 표시할 알림 페이로드.
// 서버 -> 푸시 서비스 -> 브라우저 SW(push 이벤트) 로 전달되며, SW 가 showNotification 에 사용한다.
//  - url: 알림 클릭 시 포커스/이동할 앱 내 경로 (예: '/me/orders/<id>').
//  - tag: 같은 tag 알림은 덮어쓴다 (주문별 상태 갱신이 누적되지 않게).
export interface PushNotificationPayload {
  title: string;
  body: string;
  url?: string;
  tag?: string;
}
